import { Controller } from "@hotwired/stimulus";

export default class AppController extends Controller {
  static values = {
    event: String
  }

  lastScrollTop = 0;
  scrollTimeout = null;

  connect() {
    if (this.eventValue) {
      analytics.track(this.eventValue);
    }

    document.addEventListener("scroll", this.throttledScrollDetectionHandler.bind(this));
  }

  // Copy value of input/select into `data-value` attribute. Used as CSS selector to float labels.
  floatLabels(event) {
    const element = event.target;

    if (element.matches(".input.input-group__input")) {
      element.dataset.value = element.value || "";
    }
  }

  throttledScrollDetectionHandler() {
    if (this.scrollTimeout === null) {
      this.detectScrollDirection();

      this.scrollTimeout = setTimeout(() => {
        this.scrollTimeout = null;
      }, 100);
    }
  }

  detectScrollDirection(event) {
    const scrollTop = document.documentElement.scrollTop;

    if (scrollTop > this.lastScrollTop && !document.body.classList.contains("is-scrolling-down")) {
      document.body.classList.add("is-scrolling-down");
      document.body.classList.remove("is-scrolling-up");
    } else if (scrollTop < this.lastScrollTop && !document.body.classList.contains("is-scrolling-up")) {
      document.body.classList.add("is-scrolling-up");
      document.body.classList.remove("is-scrolling-down");
    }

    this.lastScrollTop = Math.max(0, scrollTop);
  }

  scrollIntoCenter({ currentTarget }) {
    event.preventDefault();
    document.querySelector(currentTarget.getAttribute("href")).scrollIntoView({behavior: "smooth", block: "center"});
  }
}
